import React from "react";
import { Link } from "react-router-dom";

export default function RelatedJobComponent(props) {
  const { path } = props;
  const {
    id,
    company_name,
    job_title,
    job_details,
    profile_image,
    job_ctc,
    locations,
    full_time,
    part_time,
    wfh,
    intership,
  } = props.item;
  return (
    <div className="single-rated">
      <div className="d-flex justify-content-center">
        {profile_image && (
          <img
            className="img-fluid"
            src={path + encodeURI(profile_image)}
            alt={job_title ?? "NA"}
            style={{ height: "50px" }}
          />
        )}
      </div>
      {/* <img className="img-fluid" src={require("../Assets/img/r1.jpg")} alt="" /> */}
      <Link to={`/job-detail/${id}`}>
        <h4>{job_title ?? "NA"}</h4>
      </Link>
      <h6>{company_name ?? "NA"}</h6>
      {/* <p dangerouslySetInnerHTML={{ __html: job_details }}></p> */}
      <h5>
        Job Nature: {full_time === "Yes" ? "Full-Time, " : ""}
        {part_time === "Yes" ? "Part-Time, " : ""}
        {wfh === "Yes" ? "Work From Home, " : ""}
        {intership === "Yes" ? "Internship " : ""}
      </h5>
      <p className="address">
        <span className="lnr lnr-map" /> {locations ?? "NA"}
      </p>
      <p className="address">
        <span className="lnr lnr-database" /> {job_ctc ?? "NA"}
      </p>
      <Link to={`/job-detail/${id}`} className="btns text-uppercase">
        Apply job
      </Link>
    </div>
  );
}
